import * as base from 'store/bolt/pixels.js';
import Store from 'store/store';

// copied from universal

function firePageLoad() {
	let {
		activePage,
		appData: {
			meta: {
				title: {
					en: movieName
				},
				dates: {
					release: releaseDate
				},
				region: {
					slug
				},
				movieIMDBID,
				dataLayer = {}
			}
		}
	} = Store.get();

	if (activePage.startsWith('bolt')) {
		activePage = activePage.replace('bolt', '');
	}

	let {
		content_genome = '-',
		essence_genre = '-',
		fs_o,
		genre_1 = '-',
		imdb_id
	} = dataLayer || {};

	if (!fs_o || fs_o === '') {
		fs_o = undefined;
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'Landing',
		'site': {
			'name': `${movieName} Movie - Showtimes Site`,
			'market': slug,
			'template': 'Powster'
		},
		'page': {
			'name': activePage,
			'type': 'Showtimes'
		},
		'movie': {
			'name': movieName,
			'release_date': releaseDate,
			'imdb_id': imdb_id || movieIMDBID || '-',
			'genre': {
				essence_genre,
				genre_1,
				fs_o,
				content_genome
			},
		}
	});
}

function fireSocialPlatform(label) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'SocialLinkShare',
		'eventAction': label
	});
}

function fireHomeEntConversion(data) {
	const {
		appData: {
			meta: {
				title: {
					en: movieName
				}
			}
		}
	} = Store.get();

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'RetailerClick',
		'movieName': movieName,
		'merchant': data.merchant
	});
}

function fireDownloadAsset(imageName) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'Download',
		'type': 'image',
		'label': imageName
	});
}

// not conversion, just button to open boltShowtimes
function fireGetTicketsButton() {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'GetTickets'
	});
}

function fireCtaButtonClick(label) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'CTAButtonClick',
		'buttonLabel': label,
	});
}


Store.on('LANDING', () => {
	firePageLoad();
	setTimeout(() => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': '3secDwell',
		});
	}, 3000);

	var s = document.createElement( 'script' );
	s.setAttribute( 'src', 'https://cdn.cookielaw.org/opt-out/otCCPAiab.js' );
	s.setAttribute( 'charset', 'UTF-8' );
	s.setAttribute( 'ccpa-opt-out-ids', 'USP' );
	s.setAttribute( 'ccpa-opt-out-geo', 'US' );
	s.setAttribute( 'ccpa-opt-out-lspa', 'false' );
	document.body.appendChild( s );
});


Store.on('CLICKED_SHARE', ({ label }) => {
	fireSocialPlatform(label);
});

Store.on('HOME_ENT_CONVERSION', (data) => {
	fireHomeEntConversion(data);
});

Store.on('GALLERY_DOWNLOAD_IMAGE', (imageName) => {
	fireDownloadAsset(imageName);
});

Store.on('GALLERY_DOWNLOAD_ALL', () => {
	fireDownloadAsset('GALLERY_DOWNLOAD_ALL');
});

Store.on('SYNOPSIS_DOWNLOAD_IMAGE', (imageName) => {
	fireDownloadAsset(imageName);
});

Store.on('TICKET_CONVERSION', (data) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'TicketClick',
		'city': data.theater.address.local.city,
		'format': data.format,
		'date': data.date,
		'day': data.day,
		'time': data.time,
		'theaterName': data.theaterName
	});
});

Store.on('HEADER_PERSISTENT_BUTTON_CLICK', (action, category, label, options, path) => {
	fireCtaButtonClick(label);
	if (path === 'boltShowtimes') {
		fireGetTicketsButton();
	}
});

Store.on('MOVIE_DETAILS_BUTTON_CLICK', (page, label, path) => {
	fireCtaButtonClick(label);
	if (path === 'boltShowtimes') {
		fireGetTicketsButton();
	}
});

Store.on('VIDEO_PLAYER_PROGRESS', (data) => {
	const { platform, video, step } = data;

	if (step === 0) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'VideoPlay',
			'platform': platform,
			'video': video
		});
	}
});

Store.on('CALENDAR_CLICKED', ({ label }) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'SetReminder',
		'type': label
	});
});
